import type { SxProps, Theme } from '@mui/material/styles'
import { banhangKiotLike } from '@/components/layout/banhangKiotTokens'

/** Bo góc nút KiotViet (modal Lưu/Hủy, toolbar…). */
export const KIOT_BUTTON_RADIUS_PX = 8

const kiotBtnFont = {
  fontFamily: banhangKiotLike.kiotFontStack,
  fontSize: `${banhangKiotLike.kiotFontSizePx}px`,
  lineHeight: banhangKiotLike.kiotLineHeight,
  textTransform: 'none' as const,
  boxSizing: 'border-box' as const,
  boxShadow: 'none',
}

/** Style nền tảng — mọi nút Kiot trong project. */
export const kiotButtonBaseSx: SxProps<Theme> = {
  ...kiotBtnFont,
  fontWeight: 600,
  minHeight: 34,
  height: 34,
  px: 2,
  py: 0,
  borderRadius: `${KIOT_BUTTON_RADIUS_PX}px`,
  '&:hover': { boxShadow: 'none' },
}

/** Hủy / Đóng — viền xám, nền trắng. */
export const kiotButtonCancelSx: SxProps<Theme> = {
  ...kiotButtonBaseSx,
  minWidth: 96,
  border: '1px solid #cfd5dc',
  bgcolor: '#ffffff',
  color: '#3e464f',
  '&:hover': {
    borderColor: '#bcc4cc',
    bgcolor: '#f7f9fb',
    boxShadow: 'none',
  },
  '&.Mui-disabled': {
    opacity: 1,
    color: '#9aa3ab',
    borderColor: '#e2e6ea',
    bgcolor: '#f4f6f8',
  },
}

const kiotContainedDisabledOverlay =
  'linear-gradient(rgba(255,255,255,0.38), rgba(255,255,255,0.38))'

/** Lưu / Xác nhận — contained primary. */
export const kiotButtonPrimarySx: SxProps<Theme> = {
  ...kiotButtonBaseSx,
  minWidth: 104,
  '&.Mui-disabled': {
    opacity: 1,
    color: '#ffffff',
    boxShadow: 'none',
    bgcolor: 'primary.main',
    backgroundImage: kiotContainedDisabledOverlay,
  },
  '&.MuiButton-containedSuccess.Mui-disabled': {
    bgcolor: 'success.main',
    backgroundImage: kiotContainedDisabledOverlay,
  },
  '&.MuiButton-containedError.Mui-disabled': {
    bgcolor: 'error.main',
    backgroundImage: kiotContainedDisabledOverlay,
  },
}

/**
 * Nút «Thêm …» trong section form (địa chỉ / CTY / STK) —
 * gọn, viền primary, đồng bộ Kiot (giống logistics addCty).
 */
export const kiotFormInlineAddButtonSx: SxProps<Theme> = {
  ...kiotBtnFont,
  fontWeight: 600,
  minHeight: 28,
  height: 28,
  maxHeight: 28,
  px: 1,
  py: 0,
  minWidth: 0,
  borderRadius: `${KIOT_BUTTON_RADIUS_PX}px`,
  border: '1px solid',
  borderColor: 'primary.main',
  bgcolor: '#ffffff',
  color: 'primary.main',
  boxShadow: 'none',
  '&:hover': {
    borderColor: 'primary.dark',
    bgcolor: 'rgba(25, 118, 210, 0.08)',
    boxShadow: 'none',
  },
  '&.Mui-disabled': {
    borderColor: 'action.disabledBackground',
    color: 'action.disabled',
    bgcolor: '#ffffff',
  },
  '& .MuiButton-startIcon': {
    marginLeft: 0,
    marginRight: 0.4,
    '& > *:nth-of-type(1)': { fontSize: '1rem' },
  },
}

/** Thanh nút cuối form / modal footer. */
export const kiotFormActionsBarSx: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: 1,
  rowGap: 0.75,
}

export const kiotModalFooterSx: SxProps<Theme> = {
  flexShrink: 0,
  flexWrap: 'wrap',
  rowGap: 0.5,
  px: { xs: 2, sm: 2.5 },
  pt: 1.5,
  pb: 1.5,
  mt: 'auto',
  borderTop: '1px solid',
  borderColor: 'divider',
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  columnGap: 0.75,
  bgcolor: 'transparent',
}

export const kiotModalDialogActionsSx: SxProps<Theme> = {
  ...kiotModalFooterSx,
}
